import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
// Modules imports
import auth from 'resources/js/store/modules/auth/auth'
import crm_options from 'resources/js/store/modules/crm/options';
import right_info from "resources/js/store/modules/right_info";
import general from 'resources/js/store/modules/general'
import sidebar from "resources/js/store/modules/sidebar";

import workers from 'resources/js/store/modules/workers';
import news from 'resources/js/store/modules/news';

import notes from 'resources/js/store/modules/notes';
import logs from 'resources/js/store/modules/logs';
import files from 'resources/js/store/modules/files';

import companies from 'resources/js/store/modules/companies/companies';
import company_credit_finance from 'resources/js/store/modules/companies/company_credit_finance';
import company_health_check from 'resources/js/store/modules/companies/company_health_check';
import company_payment_process_info from 'resources/js/store/modules/companies/company_payment_process_info';
import company_pre_agreement from "resources/js/store/modules/companies/company_pre_agreement";
import company_referrals from "resources/js/store/modules/companies/company_referrals";
import company_services from "resources/js/store/modules/companies/company_services";

import contacts from 'resources/js/store/modules/contacts';

import addresses from "resources/js/store/modules/contact_info/addresses";
import contact_info from "resources/js/store/modules/contact_info/contact_info";

import orders from "resources/js/store/modules/orders"
import order_rates from "resources/js/store/modules/orders/order_rates";

import timesheets from "resources/js/store/modules/timesheets";
import assignments from "resources/js/store/modules/assignments";

import client_timesheets from "resources/js/store/modules/clients/timesheets";
import client_info from "resources/js/store/modules/clients/info";

import applicants from "resources/js/store/modules/applicants";
import geotec from "resources/js/store/modules/geotec";

Vue.use(Vuex);

//vue devtools - disable on production
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = false;

const vuexPersist = new VuexPersist({
 key: 'orcaCRM',
 storage: sessionStorage
});

export default new Vuex.Store({
 modules: {
  auth,
  crm_options,
  right_info,
  general,
  sidebar,
  geotec,
  news,
  workers,
  
  notes,
  logs,
  files,
  
  companies,
  company_credit_finance,
  company_health_check,
  company_payment_process_info,
  company_pre_agreement,
  company_referrals,
  company_services,
  
  contacts,
  
  addresses,
  contact_info,
  
  orders,
  order_rates,
  timesheets,
  assignments,

  client_timesheets,
  client_info,
 
  applicants
 },
 plugins: [vuexPersist.plugin]
})
